import { TtzkPortalValidationUtil } from "./ttzk-portal-validation-util";
import { NoticeRequest } from "../../../../components/pages/ttzk-portal/notices-create";

export const NoticeValidationConstant = {
  MAX_TITLE_LENGTH: 50,
  MAX_CONTENT_LENGTH: 2000,
};

export const NoticeValidationErrors = {
  title: "50文字以内で入力してください",
  content: "2,000文字以内で入力してください",
};

export const NoticeValidator = {
  isValid: (notice: NoticeRequest) => {
    return (
      NoticeValidator.title(notice.title) &&
      NoticeValidator.content(notice.content)
    );
  },
  title: (v: string | null = null) =>
    TtzkPortalValidationUtil.isNotEmptyShorterThan(
      v || "",
      NoticeValidationConstant.MAX_TITLE_LENGTH,
    ),
  content: (v: string | null = null) =>
    TtzkPortalValidationUtil.isNotEmptyShorterThan(
      v || "",
      NoticeValidationConstant.MAX_CONTENT_LENGTH,
    ),
};
